import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useSoyuzLocales } from '@spotahome/soyuz/client';

import getGqlClient from '../graphql/client';
import { getCitiesQuery } from '../graphql/queries/cities';

const CitiesContext = React.createContext();

export const CitiesProvider = ({
  children,
  initialCityInfo,
  skipAllCities
}) => {
  const { current: currentLocale } = useSoyuzLocales();
  const [cities, setCities] = useState(
    initialCityInfo ? [initialCityInfo] : []
  );

  useEffect(() => {
    const requestCities = async () => {
      try {
        const citiesResponse = await getCitiesQuery(getGqlClient())(
          currentLocale
        );

        setCities(citiesResponse.data.cities);
      } catch (error) {
        console.log(error);
        setCities(initialCityInfo ? [initialCityInfo] : []);
      }
    };

    if (!skipAllCities) {
      requestCities();
    }
  }, []);

  return (
    <CitiesContext.Provider value={{ cities }}>
      {children}
    </CitiesContext.Provider>
  );
};

CitiesProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  initialCityInfo: PropTypes.shape({
    id: PropTypes.string,
    currencyIsoCode: PropTypes.string,
    cityName: PropTypes.string
  }),
  skipAllCities: PropTypes.bool
};

CitiesProvider.defaultProps = {
  initialCityInfo: null,
  skipAllCities: false
};

export const useCitiesContext = () => useContext(CitiesContext);

export const useCityName = cityId => {
  const { cities } = useCitiesContext();
  const selectedCity = cities.find(city => city.id === cityId);

  return selectedCity ? selectedCity.cityName : '';
};

export const useCityCurrency = cityId => {
  const { cities } = useCitiesContext();
  const selectedCity = cities.find(city => city.id === cityId);

  return selectedCity ? selectedCity.currencyIsoCode : 'EUR';
};

export default {
  CitiesProvider,
  useCitiesContext,
  useCityName,
  useCityCurrency
};
